import { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Radar, LogOut, LayoutDashboard, Gift, User, ClipboardCheck, QrCode, CreditCard, Wand2, ArrowLeft, Bot, Images, Sparkles, PawPrint, Target, Ticket, Megaphone, Lock, Crown, MessageCircle, Gift as GiftIcon, Handshake } from "lucide-react";

// Módulos que pertenecen al PAQUETE HOLA RADAR ($990). Con PAQUETE CUPONES se ven desvanecidos.
const FULL_ONLY = { referidos: "Ventas Referidas", offers: "Ofertas", design: "Diseño IA", "sales-ai": "IA Vendedora", aura: "Aura & Minutos", manada: "MANADA", atinale: "Atínale al Precio", catalog: "Catálogo", redemptions: "Entregas", qr: "QR Radar" };
import api from "@/lib/api";
import UpgradeDialog, { UpgradeBanner, useUpgradeGate } from "@/components/hola/UpgradeDialog";
import { toast } from "sonner";

export default function DashboardShell({ children, active }) {
  const navigate = useNavigate();
  const [merchant, setMerchant] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setMerchant(data);
      } catch (e) {
        navigate("/login");
      } finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.warn("silent error:", e && e.message || e); }
    localStorage.removeItem("holaradar_merchant_token");
    toast.success("Sesión cerrada");
    navigate("/");
  };

  const tier = merchant?.subscription?.tier || "full";
  const locked = (k) => tier === "cupones" && !!FULL_ONLY[k];
  const pageLocked = locked(active);
  const [upgradeOpen, setUpgradeOpen] = useUpgradeGate(pageLocked);

  if (loading) {
    return <div className="min-h-screen grid place-items-center text-sm text-neutral-500">Cargando...</div>;
  }
  if (!merchant) return null;

  return (
    <div className="min-h-screen flex bg-[#FAFAFA]">
      {/* Sidebar */}
      <aside className="w-64 shrink-0 border-r border-neutral-200 bg-white p-5 hidden md:flex flex-col">
        <Link to="/" className="flex items-center gap-2 mb-8">
          <div className="w-9 h-9 rounded-xl bg-[#0055FF] text-white grid place-items-center">
            <Radar className="w-5 h-5" />
          </div>
          <span className="font-heading font-extrabold">HOLA RADAR</span>
        </Link>
        <nav className="flex-1 space-y-1">
          <NavLink to="/dashboard" active={active === "home"} icon={LayoutDashboard}>Dashboard</NavLink>
          <NavLink to="/dashboard/cupones" active={active === "cupones"} icon={Ticket}>Cupones</NavLink>
          <NavLink to="/dashboard/campanas" active={active === "campanas"} icon={Megaphone}>Base de datos & Campañas</NavLink>
          <NavLink to="/dashboard/sorteo" active={active === "sorteo"} icon={GiftIcon}>Sorteo mensual</NavLink>
          <NavLink to="/dashboard/chat" active={active === "chat"} icon={MessageCircle}>Chat en vivo</NavLink>
          {tier === "cupones" && <div className="pt-3 pb-1 px-3 text-[10px] uppercase tracking-widest font-bold text-neutral-400 flex items-center gap-1"><Lock className="w-3 h-3" /> Paquete HOLA RADAR</div>}
          <NavLink to="/dashboard/referidos" active={active === "referidos"} icon={Handshake} locked={locked("referidos")}>Ventas Referidas</NavLink>
          <NavLink to="/dashboard/offers" active={active === "offers"} icon={Gift} locked={locked("offers")}>Ofertas</NavLink>
          <NavLink to="/dashboard/design" active={active === "design"} icon={Wand2} locked={locked("design")}>Diseño IA</NavLink>
          <NavLink to="/dashboard/sales-ai" active={active === "sales-ai"} icon={Bot} locked={locked("sales-ai")}>IA Vendedora</NavLink>
          <NavLink to="/dashboard/aura" active={active === "aura"} icon={Sparkles} locked={locked("aura")}>Aura & Minutos</NavLink>
          <NavLink to="/dashboard/manada" active={active === "manada"} icon={PawPrint} locked={locked("manada")}>MANADA (grupos)</NavLink>
          <NavLink to="/dashboard/atinale" active={active === "atinale"} icon={Target} locked={locked("atinale")}>Atínale al Precio</NavLink>
          <NavLink to="/dashboard/catalog" active={active === "catalog"} icon={Images} locked={locked("catalog")}>Catálogo (10 fotos)</NavLink>
          <NavLink to="/dashboard/redemptions" active={active === "redemptions"} icon={ClipboardCheck} locked={locked("redemptions")}>Entregas</NavLink>
          <NavLink to="/dashboard/qr" active={active === "qr"} icon={QrCode} locked={locked("qr")}>QR Radar</NavLink>
          <NavLink to="/dashboard/billing" active={active === "billing"} icon={CreditCard}>Suscripción</NavLink>
          <NavLink to="/dashboard/profile" active={active === "profile"} icon={User}>Mi comercio</NavLink>
        </nav>
        <div className="pt-4 border-t border-neutral-200">
          <div className="text-xs text-neutral-500 mb-2">Sesión</div>
          <div className="text-sm font-bold truncate" data-testid="merchant-name">{merchant.business_name}</div>
          <div className={`mt-1 inline-flex items-center gap-1 text-[10px] font-extrabold uppercase tracking-widest rounded-full px-2 py-0.5 ${tier === "cupones" ? "bg-[#FF007A]/10 text-[#FF007A]" : "bg-[#0055FF]/10 text-[#0055FF]"}`} data-testid="merchant-plan-badge">
            <Crown className="w-3 h-3" /> {tier === "cupones" ? "Cupones Marketing" : merchant.subscription?.is_trial ? "Prueba · todo incluido" : "HOLA RADAR"}
          </div>
          <div className="text-xs text-neutral-500 truncate">{merchant.email || merchant.phone}</div>
          <button
            onClick={logout}
            data-testid="logout-btn"
            className="mt-3 flex items-center gap-2 text-sm text-neutral-600 hover:text-black"
          >
            <LogOut className="w-4 h-4" /> Cerrar sesión
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0">
        {/* Mobile header */}
        <div className="md:hidden sticky top-0 bg-white/80 backdrop-blur-md border-b border-neutral-200 px-5 py-3 flex items-center justify-between z-30">
          <div className="flex items-center gap-2">
            {active !== "home" && (
              <Link
                to="/dashboard"
                data-testid="dashboard-back-btn"
                aria-label="Regresar al dashboard"
                className="w-8 h-8 rounded-lg hover:bg-neutral-100 grid place-items-center text-neutral-600"
              >
                <ArrowLeft className="w-4 h-4" />
              </Link>
            )}
            <div className="w-8 h-8 rounded-lg bg-[#0055FF] text-white grid place-items-center">
              <Radar className="w-4 h-4" />
            </div>
            <span className="font-heading font-extrabold text-sm truncate max-w-[9rem]">{merchant.business_name}</span>
          </div>
          <button onClick={logout} className="text-neutral-500" aria-label="Cerrar sesión"><LogOut className="w-5 h-5" /></button>
        </div>
        <div className="p-6 md:p-10 max-w-6xl relative">
          {pageLocked && <UpgradeDialog moduleName={FULL_ONLY[active]} open={upgradeOpen} onOpenChange={setUpgradeOpen} />}
          {pageLocked && !upgradeOpen && <UpgradeBanner moduleName={FULL_ONLY[active]} onOpen={() => setUpgradeOpen(true)} />}
          <div className={pageLocked ? "pointer-events-none select-none opacity-50 max-h-[80vh] overflow-hidden pt-16" : ""} aria-hidden={pageLocked}>
            {children({ merchant, setMerchant })}
          </div>
        </div>

        {/* Mobile nav */}
        <div className="md:hidden fixed bottom-4 left-4 right-4 z-30">
          <div className="glass rounded-full p-1.5 flex items-center justify-around border border-neutral-200 shadow-lg">
            <MobileTab to="/dashboard" active={active === "home"} icon={LayoutDashboard} label="Inicio" />
            <MobileTab to="/dashboard/offers" active={active === "offers"} icon={Gift} label="Ofertas" />
            <MobileTab to="/dashboard/cupones" active={active === "cupones"} icon={Ticket} label="Cupones" />
            <MobileTab to="/dashboard/redemptions" active={active === "redemptions"} icon={ClipboardCheck} label="Entregas" />
            <MobileTab to="/dashboard/qr" active={active === "qr"} icon={QrCode} label="QR" />
            <MobileTab to="/dashboard/profile" active={active === "profile"} icon={User} label="Perfil" />
          </div>
        </div>
      </main>
    </div>
  );
}

function NavLink({ to, active, icon: Icon, children, locked = false }) {
  return (
    <Link
      to={to}
      title={locked ? "Incluido en el PAQUETE HOLA RADAR" : undefined}
      className={`flex items-center gap-3 px-3 py-2.5 rounded-xl font-semibold text-sm transition-colors ${
        active ? "bg-[#0055FF] text-white" : locked ? "text-neutral-400 opacity-60 hover:opacity-90 hover:bg-neutral-50" : "text-neutral-600 hover:bg-neutral-100"
      }`}
      data-testid={`nav-${to.replace("/dashboard", "").replace("/", "") || "home"}`}
      data-locked={locked ? "true" : undefined}
    >
      <Icon className="w-4 h-4" /> <span className="flex-1">{children}</span> {locked && <Lock className="w-3 h-3" />}
    </Link>
  );
}

function MobileTab({ to, active, icon: Icon, label }) {
  return (
    <Link
      to={to}
      className={`flex-1 flex flex-col items-center py-2 rounded-full text-xs font-bold ${
        active ? "bg-[#0055FF] text-white" : "text-neutral-500"
      }`}
    >
      <Icon className="w-4 h-4 mb-0.5" /> {label}
    </Link>
  );
}
